import { useQuery } from "react-query";
import { request } from "../../../config/helpers/axios-instance";
import { throwIfRequestError } from "../../hooks/request-error";

// Finance COD tab — GET /api/payment/admin, filtered to COD payments (§5's Change 5).
// The row entity is `payments`, not `userOrders` (product-owner decision, §5): an order
// paid partly by UPI and partly COD contributes only its COD payment line here.
//
// Sends `cod=true` rather than `paymentMethod=CASH_ON_DELIVERY`. Both filter correctly
// today, but which methods count as COD is a backend policy decision, not a frontend
// one: it lives in PaymentConstants.COD_PAYMENT_METHODS so that including `CASH` later
// (§5 DEFAULT currently excludes it — money already taken at a counter, not money still
// owed on delivery) is a one-line change there. A hardcoded method string here cannot
// express a list, and would silently disagree with that constant the moment it changes.
export default function useFinanceCod({ page = 1, size = 20, enabled = true } = {}) {
    const params = { page, size, cod: true };

    return useQuery(
        ["finance-cod", params],
        async () => {
            const result = await request({ url: "payment/admin", method: "GET", params });
            throwIfRequestError(result);
            const body = result.data;
            if (!body?.success) throw body;

            const { count, rows } = body.data;
            return {
                payments: rows || [],
                pagination: { page, size, total: Number(count) || 0 },
            };
        },
        { keepPreviousData: true, retry: false, enabled }
    );
}
